export const locale = {
  GLOBAL: {
    Title: "ՍՄՍ Լենդ",
    PostalCode: "Փոստային ինդեքս",
    postalCodes: "Փոստային ինդեքսներ",
    selectedPostalCodes: "Ընտրված փոստային ինդեքսներ",
    MciNumberCount: "Համարների քանակ՝ MCI",
    MtuNumberCount: "Համարների քանակ՝ Irancell",
    TotalCount: "Ընդհանուր քանակ",
    Coefficient: "Գործակից",
    Back: "Հետ",
  },
  ERRORS: {
    PhoneIsNotValid: "Մուտքագրված հեռախոսահամարը ճիշտ չէ: օրինակ՝ 09101234567",
    InvalidNumber: "Մուտքագրված թիվը ճիշտ չէ",
    NoSelectedLineNumber: "Ընտրեք ուղարկող գիծը:",
    EmptyText: "Խնդրում ենք մուտքագրել տեքստը:",
    UnknownError: "Անհայտ սխալ",
    TryAgain: "Խնդրում ենք մի փոքր ուշ կրկին փորձել:",
    NoAccountCharge: "Անբավարար միջոցներ",
    NoAccess: "Դուք մուտք չունեք:",
    PleasebyeAPlane: "Խնդրում ենք գնել փաթեթ:",
    PleaseChargeYourAccount: "Խնդրում ենք լիցքավորել Ձեր հաշիվը:",
    AccessDenied: "Մուտքն արգելված է:",
    AccessDeniedDescription:
      "Լրացուցիչ տեղեկությունների համար դիմեք աջակցության ծառայությանը",
    Error: "Սխալ",
    InvalidText: "Տեքստը անվավեր է",
    InvalidTextContainsLink:
      "Հղում պարունակող տեքստ կարող են ուղարկել միայն սպասարկման գծերը:",
  },
  INFOS: {
    SuccessSentSms: "Հաղորդագրությունը ուղարկվել է",
    SmsRequestInQueue:
      "Ձեր հաղորդագրությունը կուղարկվի ադմինիստրատորի հաստատումից հետո",
    SendData: "Ուղարկման տվյալներ",
    CheckData: "Խնդրում ենք կարդալ և հաստատել ստորև նշված տեղեկությունները:",
  },
  TOBE: {
    to: "դեպի ",
    from: "ից ",
  },
  FORMS: {
    DestinationPhone: "Ստացողի հեռախոսահամար",
    TestDestinationPhone: "Թեստային հեռախոսահամար",
    SourceNumber: "Ուղարկողի համար",
    Text: "Տեքստ",
    CharCount: "Նիշերի քանակ",
    FarsiCharCount: "Պարսկերեն նիշեր",
    EnglishCharCount: "Անգլերեն նիշեր",
    Send: "Ուղարկել",
    SendTime: "Ուղարկման ժամանակ",
    SendTest: "Թեստային ուղարկում",
    SendToTestNumber: "Ուղարկել թեստային համարին",
    SmsCount: "SMS-ների քանակ",
    SmsLang: "SMS-ի լեզու",
    Add: "Ավելացնել",
    FromFile: "Ավելացնել ֆայլից",
    TestNumber: "Թեստային համար",
    Test: "Թեստ",
    ServiceRelated: "Ծառայություն",
    Price: "Գին",
    NumbersCount: "Համարների քանակ",
    NumbersCountToSend: "Համարներ, որոնց կուղարկվի հաղորդագրություն",
    Search: "Որոնել",
    Title: "Անվանում",
    RequestTime: "Հայտի ժամանակ",
    RequestInformation: "Հայտի տվյալներ",
    CreateNewPhoneBook: "Ստեղծել նոր հեռախոսագիրք",
  },
  BUTTONS: {
    OK: "Լավ",
    AccountCharge: "Լիցքավորել հաշիվը",
    Reports: "Հաշվետվություններ",
    RemoveAll: "Ջնջել բոլորը",
    BuyAPlane: "Գնել փաթեթ",
    Accept: "Հաստատել",
    Reject: "Մերժել",
    Yes: "Այո",
    No: "Ոչ",
    Create: "Ստեղծել",
    New: "Նոր",
    Save: "Պահպանել",
    Delete: "Ջնջել",
    More: "Ավելին",
    TryAgain: "Կրկին փորձել",
    Close: "Փակել",
    RollBack: {
      back: "Վերադառնալ նախորդ օգտատիրոջը",
      goToMainUser: "Վերադառնալ գլխավոր օգտատիրոջը",
      CurrentUser: "Ընթացիկ օգտատեր",
    },
  },
  DIALOGS: {
    Waiting: "Խնդրում ենք սպասել",
    RejectItQuestion: "Մերժե՞լ",
    AcceptItQuestion: "Հաստատե՞լ",
    Rejected: "Մերժվել է",
    Accepted: "Հաստատվել է",
    Error: "Սխալ",
  },
  CONFIRM: {
    Delete: "Համոզվա՞ծ եք, որ ցանկանում եք ջնջել:",
    DeleteA: "Համոզվա՞ծ եք, որ ցանկանում եք ջնջել {a}-ն:",
    DeleteALL: "Համոզվա՞ծ եք, որ ցանկանում եք ջնջել բոլորը:",
  },
  LANGUAGE: {
    English: "Անգլերեն",
    Persian: "Պարսկերեն",
  },
  language: {
    selectAll: "Ընտրել բոլորը",
    lang: {
      fa: "Պարսկերեն",
      ar: "Արաբերեն",
      ar_ae: "Արաբերեն (ԱՄԷ)",
      ar_iq: "Արաբերեն (Իրաք)",
      en_US: "Անգլերեն (ԱՄՆ)",
      en_GB: "Անգլերեն (Մեծ Բրիտանիա)",
      de: "Գերմաներեն",
      fr: "Ֆրանսերեն",
      zh_CN: "Պարզեցված չինարեն",
      zh_TW: "Ավանդական չինարեն",
      tr: "Թուրքերեն",
      ru: "Ռուսերեն",
      hy: "Հայերեն",
    },
    only_manual_now: "Ներկայումս հասանելի է միայն ձեռքով թարգմանություն",
    ai_coming_soon: "ԱԲ թարգմանությունը շուտով կակտիվանա",
    got_it: "Հասկացա",
    origin_language: "Ելակետային լեզու",
    target_languages: "Թիրախային լեզուներ",
    remove_all: "Հեռացնել բոլոր լեզուները",
    translation_method: "Ընտրել թարգմանության մեթոդը",
    manual_translation: "Ձեռքով թարգմանություն",
    ai_translation: "ԱԲ թարգմանություն",
    coming_soon: "Շուտով",
    source_language_updated: "Ելակետային լեզուն թարմացվել է",
    error_changing_source_language: "Սխալ ելակետային լեզու փոխելիս",
    source_language_created: "Ստեղծվել է նոր ելակետային լեզու",
    languages_saved: "Նոր լեզուները պահպանվել են",
    error_saving_languages: "Սխալ լեզուներ պահպանելիս",
    error_loading_language: "Սխալ լեզու բեռնելիս",
    languages_removed: "Հեռացված լեզուներ",
    new_languages_to_save: "Պահպանման համար նոր լեզուներ",
    saved: "Պահպանվել է",
    management_langs: "Լեզուների կառավարում",
    add_langs: "Ավելացնել լեզու",
    change_language: "Փոխել լեզուն",
    visit_card: "Այցելության քարտ",
    translate_to: "Թարգմանել դեպի",
    main_language: "լեզու",
    no_languages_available: "Հասանելի լեզու չկա",
    return_to_default: "Վերադառնալ լռելյայն լեզվին",
    translate: "Թարգմանել",
    changes_pending: "Սպասում է փոփոխությունների կիրառմանը",
    apply_changes: "Կիրառել փոփոխությունները",
    cancel_changes: "Չեղարկել",
  },
  LISTS: {
    NoData: "Տվյալներ չկան",
    NoDataFound: "Տվյալներ չեն գտնվել",
    NoDataFoundFor: "{a}-ի համար տվյալներ չեն գտնվել",
    NoPhoneNumber: "Հեռախոսահամար չի գտնվել",
    NoPostalCode: "Փոստային ինդեքս չի գտնվել",
    AddANumber: "Ավելացրեք համար",
    City: "Քաղաք",
    AddedBefore: "Արդեն ավելացված է",
  },
  PAGES: {
    SendSms: "Ուղարկել SMS",
    MapSms: "Ուղարկել քարտեզով",
    PhoneBook: "Հեռախոսագիրք",
  },
  MONETARY: {
    Rial: "Ռիալ",
  },
  HINTS: {
    SendMessageTitle:
      "Անվանումը կամայական է: Դուք կարող եք օգտագործել նախկինում ուղարկված հաղորդագրությունների անվանումները, որպեսզի տեքստն ավտոմատ լրացվի: Անվանումը չի ուղարկվում հաղորդագրության մեջ, այն օգտագործվում է միայն հաշվետվությունների և առաջարկությունների համար:",
    SendMessageTime:
      "Ուղարկման ժամանակը այն պահն է, երբ Ձեր հաղորդագրությունը մտնում է ուղարկման հերթ: Ուշադրություն՝ առանց ադմինիստրատորի հաստատման հաղորդագրությունը չի ուղարկվի:",
    CreatePhoneBook:
      "SMS ուղարկելիս համարներ ավելացնելու համար կօգտագործվի այս անվանումը:",
  },
  TOASTS: {
    SuccessCreate: "Հաջողությամբ ստեղծվել է",
    FailedCreated: "Սխալ ստեղծման ժամանակ",
    SuccessDelete: "Ջնջվել է",
    FailedDelete: "Սխալ ջնջման ժամանակ",
    SuccessEdit: "Խմբագրվել է",
    FailedEdit: "Սխալ խմբագրման ժամանակ",
    AddedSuccess: "Ավելացվել է",
    AddedFailed: "Սխալ ավելացման ժամանակ",
  },
  WALLET: {
    CustomCharge: "Կամայական գումար",
    GateWay: "Վճարման դարպաս",
    Price: "Գումար",
    Details: [
      "Մուտքագրված գումարին կավելացվի 9% հարկ:",
      "Խնդրում ենք ուշադիր մուտքագրել գումարը, վճարված գումարը հետ չի վերադարձվում:",
    ],
    noGateWay: "Ձեզ համար վճարման դարպաս սահմանված չէ:",
    PriceNotInRange: "Գումարը պետք է լինի {min} ռիալից մինչև {max} ռիալ:",
    Pay: "Վճարել",
    ErrorOnRedirectToGateWay: "Սխալ՝ վճարման դարպաս տեղափոխվելիս",
    ChargeWalletButtonDescription: "Սեղմեք + կոճակը՝ հաշիվը լիցքավորելու համար",
  },
  login: {
    phoneField: {
      placeholderIran: "Սկսեք 9-ով (օրինակ՝ +98 912 345 6789)",
      placeholderDefault: "Մուտքագրեք Ձեր հեռախոսահամարը",
      maxDigitsError: "Թույլատրվում է առավելագույնը {count} նիշ:",
      iranMustStartWith9:
        "Իրանական բջջային համարը պետք է սկսվի 9-ով (օրինակ՝ 912…)",
    },
    signup_button: "Գրանցվել",
    forget_password_title: "Մոռացե՞լ եք գաղտնաբառը",
    register_title: "Անվճար գրանցում",
    login_title: "Մուտք",
    back: "Հետ",
    username_label: "Բջջային համար / Օգտանուն",
    otp_resend_button: "Կրկին ուղարկել կոդը",
    password_label: "Գաղտնաբառ",
    password_hint: "Առնվազն 8 նիշ",
    name_label: "Անուն",
    name_rule: "Առնվազն 3 նիշ",
    lastname_label: "Ազգանուն",
    phone_label: "Բջջային հեռախոս",
    nid_label: "Ազգային կոդ",
    parent_phone_label: "Հրավիրողի հեռախոսահամար (ըստ ցանկության)",
    terms_and_conditions_message:
      "Գրանցումը համարվում է գովազդային տերմինալի կանոնների ընդունում",
    terms_and_conditions_link: "Կանոններ և պայմաններ",
    close: "Փակել",
    forgot_password_link: "Մոռացե՞լ եք գաղտնաբառը",
    change_password: "Փոխել գաղտնաբառը",
    register_button: "Գրանցվել",
    login_button: "Մուտք",
    login_with_google: "Մուտք Google-ով",
    login_with_sms: "Մուտք SMS-ով",
    login_with_password: "Մուտք գաղտնաբառով",
    already_registered: "Արդեն գրանցվա՞ծ եք",
    login_here: "Մուտք",
    no_account: "Դեռ հաշիվ չունե՞ք",
    signup_now: "Գրանցվել հիմա",
    more_info: "Ավելի շատ տեղեկություն",
    text_login: "Մուտք",
    text_register: "Գրանցում",
    required_field: "Պարտադիր դաշտ:",
    min_8_char: "Դաշտը պարունակում է 8 նիշից պակաս",
    required: "Այս դաշտը պարտադիր է",
    min_3_char: "Առնվազն 3 նիշ",
    max_50_char: "Առավելագույնը 50 նիշ",
    no_internet: "Դուք կապված չեք ինտերնետին",
    no_phone_entered: "Դուք չեք մուտքագրել համար",
    otp_sent_successfully: "Հաստատման կոդը հաջողությամբ ուղարկվել է:",
    please_register_first: "Խնդրում ենք նախ գրանցվել:",
    wait_3_min: "Խնդրում ենք սպասել 3 րոպե և կրկին փորձել:",
    login_successful: "Դուք հաջողությամբ մուտք եք գործել",
    internet_connection_error: "Ինտերնետ կապի խնդիր:",
    agree_to_terms_error: "Դուք չեք ընդունել կանոններն ու պայմանները:",
    otp_sent_successfully_register: "Հաստատման կոդը հաջողությամբ ուղարկվել է:",
    error: "Սխալ",
    registration_nid_required_notice:
      "Ծառայությունների բարձր անվտանգություն ապահովելու և խարդախությունից (ֆիշինգ) պաշտպանվելու համար գրանցման ժամանակ ազգային կոդի մուտքագրումը պարտադիր է:",
  },
  home: {
    title: "Գլխավոր էջ",
    selectSystem: "Ընտրել համակարգ",
    yourPoints: "Ձեր միավորները",
    discountCodes: "Զեղչի կոդեր",
    all: "Բոլորը",
    discounts: "Զեղչեր",
    systemGuide: "Համակարգի ուղեցույց",
    yourPointsDynamic: "Ձեր միավորները՝ {points}",
    confirm: "Հաստատել",
    copy: "Պատճենել",
  },
  badges: {
    free: "Անվճար",
    preRegister: "Նախնական գրանցում",
    comingSoon: "Շուտով",
    testVersion: "Փորձարկման տարբերակ",
  },
  services: {
    qrLand: {
      title: "QR Land համակարգ",
      description: "Դինամիկ QR կոդերի ստեղծում",
      property: {
        0: "Գովազդի տեսակի և վայրի ուսումնասիրություն և ընտրություն",
        1: "Կինոթատրոններում գովազդի տեսակների ուսումնասիրություն և ընտրություն",
        2: "Առանց միջնորդավճարի և լրացուցիչ ծախսերի",
        3: "Կինոթատրոններում տեղադրված բոլոր գովազդների միասնական կառավարում",
      },
    },
    payamak: {
      title: "SMS Land համակարգ",
      description: "Գովազդային զանգվածային SMS ուղարկում",
      property: {
        0: "Զանգվածային SMS ուղարկում",
        1: "Թարմացված համարների բանկ",
        2: "Հաճախորդների ակումբին SMS ուղարկում",
        3: "Հնարավորություն է տալիս միանալ բոլոր կայքերին և ծրագրագրերին",
      },
    },
    robot: {
      title: "Robot Land համակարգ",
      description:
        "Համարների, հայտարարությունների և վահանակների միաժամանակյա կառավարում",
      property: {
        0: "Խմբային և զանգվածային հայտարարությունների գրանցում",
        1: "Ժամանակավոր, աստիճանական և խելացի կառավարում հայտարարությունների",
        2: "Հայտարարություն գրանցելու համար անսահմանափակ համարների վարձակալություն և ավելացում",
        3: "Բոլոր հայտարարությունների միաժամանակյա գրանցում և կառավարում",
      },
    },
    infoLand: {
      title: "Info Land",
      description:
        "Ավելի քան 2500 թարմացված մասնագիտությունների տվյալների բազա",
      property: {
        0: "Բոլոր մասնագիտական տվյալները",
        1: "Բոլոր քաղաքների և մարզերի դասակարգում",
        2: "Երկրի բոլոր մասայի տվյալների բանկ",
        3: "Բոլոր բանկերի նմուշները ստուգելու հնարավորություն",
      },
    },
    graphic: {
      title: "Graphic Land համակարգ",
      description: "Գրաֆիկական և վիդեո դիզայն 0-ից 100",
      property: {
        0: "Լոգո և գրասենյակային փաթեթի ձևավորում",
        1: "Տպագրության և փաթեթավորման բոլոր ծառայությունները",
        2: "Կատալոգների, բրոշյուրների և տուփերի ձևավորում",
        3: "Տարբեր չափերի բաններների ձևավորում և տպագրություն",
      },
    },
    bestWebLand: {
      title: "Best Web Land համակարգ",
      description: "Կայքի ձևավորում, սպասարկում և SEO",
      property: {
        0: "Բովանդակության SEO",
        1: "Արտաքին SEO (off-page)",
        2: "Տեխնիկական SEO (technical)",
        3: "Ներքին SEO (on-page)",
      },
    },
    onlineShop: {
      title: "Առցանց խանութ կառուցող համակարգ",
      description: "Թվային աշխարհից ընդամենը մի քանի կտտոց հեռու",
      badge: "Գործընկերային վաճառք",
      property: {
        0: "Բովանդակության SEO",
        1: "Արտաքին SEO (off-page)",
        2: "Տեխնիկական SEO (technical)",
        3: "Ներքին SEO (on-page)",
      },
    },
    social: {
      title: "Գովազդ սոցիալական ցանցերում",
      description:
        "Լավագույն էջերի և ալիքների ուսումնասիրություն և ընտրություն",
      property: {
        0: "Բարձր այցելություն ունեցող բոլոր էջերի ուսումնասիրություն",
        1: "Բոլոր գովազդների միասնական կառավարում",
        2: "Առանց միջնորդավճարի և լրացուցիչ ծախսերի",
        3: "Հավանած էջերում առցանց գովազդի պատվեր",
      },
    },
    billboard: {
      title: "Առցանց բիլբորդի վարձակալություն",
      description: "ԱՈւղղակի կապ՝ առանց միջնորդի, նպատակային ընտրությամբ",
      property: {
        0: "Բիլբորդի վայրի և տեսակի ուսումնասիրություն",
        1: "Բոլոր ընդգրկված բիլբորդների կառավարում",
        2: "Ուղղակի կապ բիլբորդի սեփականատիրոջ հետ՝ առանց միջնորդի",
        3: "Առանց միջնորդավճարի և լրացուցիչ ծախսերի",
      },
    },
    internationalMedia: {
      title: "Գովազդ ազգային լրատվամիջոցներում",
      description:
        "Հեռուստատեսությամբ և ռադիոյով գովազդի ուսումնասիրություն և տեղադրում",
      property: {
        0: "Գովազդի հրապարակման ժամանակի ուսումնասիրություն և ընտրություն",
        1: "Հեռուստատեսային գովազդի տեսակների ուսումնասիրություն և ընտրություն",
        2: "Ռադիոգովազդի տեսակների ուսումնասիրություն և ընտրություն",
        3: "Հեռուստածրագրի տեսակի մեջ գովազդի ընտրություն",
      },
    },
    transport: {
      title: "Գովազդ տրանսպորտային միջոցներում",
      description: "Օդանավակայան, երկաթուղային կայարաններ, ավտոբուսներ և մետրո",
      property: {
        0: "Գովազդի տեսակի և վայրի ուսումնասիրություն և ընտրություն",
        1: "Մետրոյում գովազդի տեղադրելու տեսակների ուսումնասիրություն",
        2: "Առանց միջնորդավճարի և լրացուցիչ ծախսերի",
        3: "Մետրոյում տեղադրված բոլոր գովազդների միասնական կառավարում",
      },
    },
    cinema: {
      title: "Գովազդ պատկերային լրատվամիջոցներում",
      description:
        "Կինոթատրոններում և վիդեո հոսքային հարթակներում գովազդի տեղադրում",
      property: {
        0: "Գովազդի տեսակի և վայրի ուսումնասիրություն և ընտրություն",
        1: "Կինոթատրոններում գովազդի տեսակների ուսումնասիրություն և ընտրություն",
        2: "Առանց միջնորդավճարի և լրացուցիչ ծախսերի",
        3: "Կինոթատրոններում տեղադրված բոլոր գովազդների միասնական կառավարում",
      },
    },
    estate: {
      title: "Առցանց անշարժ գույքի համակարգ",
      description: "Ֆայլերի, խորհրդատուների և հաճախորդների կառավարում",
      property: {
        0: "Գովազդի տեսակի և վայրի ուսումնասիրություն և ընտրություն",
        1: "Կինոթատրոններում գովազդի տեսակների ուսումնասիրություն և ընտրություն",
        2: "Առանց միջնորդավճարի և լրացուցիչ ծախսերի",
        3: "Կինոթատրոններում տեղադրված բոլոր գովազդների միասնական կառավարում",
      },
    },
    AIGeneration: {
      title: "Արհեստական բանականության համակարգ",
      description: "Պատկերների ստեղծում, չաթ-բոտեր",
    },
    ShortLink: {
      title: "Կարճ հղումների համակարգ",
      description: "Կարճ հղումների ստեղծում",
    },
    customer: {
      title: "Հաճախորդների առցանց կառավարման համակարգ",
      description: "Կառավարում, աջակցություն և հավատարիմ հաճախորդների ստեղծում",
      property: {
        0: "Գովազդի տեսակի և վայրի ուսումնասիրություն և ընտրություն",
        1: "Կինոթատրոններում գովազդի տեսակների ուսումնասիրություն և ընտրություն",
        2: "Առանց միջնորդավճարի և լրացուցիչ ծախսերի",
        3: "Կինոթատրոններում տեղադրված բոլոր գովազդների միասնական կառավարում",
      },
    },
    internetBroadcasting: {
      title: "Ինտերնետային գովազդի տեղադրում և կառավարում",
      description: "Google Ads, կտտոցային գովազդ, ռեպորտաժ",
      property: {
        0: "Գովազդի տեսակի և վայրի ուսումնասիրություն և ընտրություն",
        1: "Կինոթատրոններում գովազդի տեսակների ուսումնասիրություն",
        2: "Առանց միջնորդավճարի և լրացուցիչ ծախսերի",
        3: "Կինոթատրոններում տեղադրված բոլոր գովազդների միասնական կառավարում",
      },
    },
    emailMarketing: {
      title: "Էլեկտրոնային փոստով մարքեթինգի համակարգ",
      description: "Գովազդային նամակների ուղարկում երկրի բոլոր բիզնեսներին",
      property: {
        0: "Գովազդի տեսակի և վայրի ուսումնասիրություն և ընտրություն",
        1: "Կինոթատրոններում գովազդի տեսակների ուսումնասիրություն",
        2: "Առանց միջնորդավճարի և լրացուցիչ ծախսերի",
        3: "Կինոթատրոններում տեղադրված բոլոր գովազդների միասնական կառավարում",
      },
    },
    adsOnStudium: {
      title: "Գովազդ մարզադաշտերում և ցուցահանդեսներում",
      description: "Ձեր բրենդի ներկայությունը ամենամեծ կենտրոններում",
      property: {
        0: "Գովազդի տեսակի և վայրի ուսումնասիրություն և ընտրություն",
        1: "Կինոթատրոններում գովազդի տեսակների ուսումնասիրություն",
        2: "Առանց միջնորդավճարի և լրացուցիչ ծախսերի",
        3: "Կինոթատրոններում տեղադրված բոլոր գով գովազդների միասնական կառավարում",
      },
    },
    bidOnline: {
      title: "Առցանց աճուրդի համապարփակ համակարգ",
      description: "Առցանց աճուրդ կազմակերպեք, մասնակցեք աճուրդներին",
      property: {
        0: "Գովազդի տեսակի և վայրի ուսումնասիրություն և ընտրություն",
        1: "Կինոթատրոններում գովազդի տեսակների ուսումնասիրություն և ընտրություն",
        2: "Առանց միջնորդավճարի և լրացուցիչ ծախսերի",
        3: "Կինոթատրոններում տեղադրված բոլոր գովազդների միասնական կառավարում",
      },
    },
    onlineTools: {
      title: "Բիզնեսի առցանց գործիքների համակարգ",
      description: "Ամեն տեսակի բիզնեսի բոլոր օժանդակ գործիքները",
      property: {
        0: "Գովազդի տեսակի և վայրի ուսումնասիրություն և ընտրություն",
        1: "Կինոթատրոններում գովազդի տեսակների ուսումնասիրություն և ընտրություն",
        2: "Առանց միջնորդավճարի և լրացուցիչ ծախսերի",
        3: "Կինոթատրոններում տեղադրված բոլոր գովազդների միասնական կառավարում",
      },
    },
    onlineLearn: {
      title: "Մասնագիտությունների առցանց ուսուցման համակարգ",
      description: "Թիրախային ուսուցումների ուսումնասիրություն և ընտրություն",
      property: {
        0: "Գովազդի տեսակի և վայրի ուսումնասիրություն և ընտրություն",
        1: "Կինոթատրոններում գովազդի տեսակների ուսումնասիրություն և ընտրություն",
        2: "Առանց միջնորդավճարի և լրացուցիչ ծախսերի",
        3: "Կինոթատրոններում տեղադրված բոլոր գովազդների միասնական կառավարում",
      },
    },
    cloud: {
      title: "Հոսթինգ և դոմենի գնում",
      description: "Հոսթինգ, դոմեն և սերվեր գնել",
      property: {
        0: "Գովազդի տեսակի և վայրի ուսումնասիրություն և ընտրություն",
        1: "Կինոթատրոններում գովազդի տեսակների ուսումնասիրություն և ընտրություն",
        2: "Առանց միջնորդավճարի և լրացուցիչ ծախսերի",
        3: "Կինոթատրոններում տեղադրված բոլոր գովազդների միասնական կառավարում",
      },
    },
    QrlandShop: {
  title: "Առցանց խանութների կառավարում",
  description: "Ապրանքների, առցանց շուկաների և խելացի գնագոյացման միասնական կառավարում",
  property: {
    0: "Ապրանքների համապարփակ վերահսկում և կառավարում",
    1: "Ապրանքների տարբերակների կառավարում",
    2: "Առցանց շուկաների վերահսկում և կառավարում",
    3: "Խելացի գնագոյացման ռազմավարություններ",
  },
},

  },
  "planning.title": "Պլանավորում",
  "tabs.reminder": "Հիշեցումներ",
  "tabs.notes": "Նշումներ",
  "tabs.calendar": "Օրացույց",
  "notes.creationDate": "Ստեղծման ամսաթիվ",
  "common.save": "Պահպանել",
  "common.cancel": "Չեղարկել",
  "actions.quickActions": "Արագ գործողություններ",
  "notes.writeMessage": "Գրել նշում",
  "notes.titlePlaceholder": "Նշման վերնագիր",
  "notes.addNote": "Ավելացնել նշում",
  "notes.updatedSuccess": "Նշումը հաջողությամբ թարմացվել է:",
  "notes.addedSuccess": "Նշումը հաջողությամբ ավելացվել է:",
  "common.deletedSuccess": "Հաջողությամբ ջնջվել է",
  "common.confirmDelete": "Համոզվա՞ծ եք, որ ցանկանում եք ջնջել:",
  "news.title": "Կայքի նորություններ",
  "news.noNews": "Կայքում դեռևս նորություններ չկան:",
  "news.view": "Դիտել",
  "remember.add": "Ստեղծել հիշեցում",
  "remember.update": "Թարմացնել հիշեցումը",
  "remember.titleLabel": "Վերնագիր",
  "remember.dateLabel": "Հիշեցման ամսաթիվ",
  "remember.confirmDelete": "Համոզվա՞ծ եք, որ ցանկանում եք ջնջել:",
  "remember.deleteSuccess": "Հիշեցումը հաջողությամբ ջնջվել է:",
  "remember.createSuccess": "Նոր հիշեցումը ստեղծվել է:",
  "remember.updateSuccess": "Հիշեցումը թարմացվել է:",
  "points.receivedAwards": "Ստացված պարգևներ",
  "points.pointsHistory": "Միավորների պատմություն",
  "points.points": "Միավոր",
  "points.discountTitle": "Robot Land զեղչ",
  "points.discountText": "Յուրաքանչյուր 500 միավորի դիմաց",
  events: {
    title: "Իրադարձություններ",
    addEvent: "Ավելացնել իրադարձություն",
    calendar: "Հիմնական օրացույց",
    close: "Փակել",
    save: "Պահպանել",
    update: "Թարմացնել",
    confirmDelete: "Համոզվա՞ծ եք, որ ցանկանում եք ջնջել:",
    successAdd: "Հաջողությամբ ավելացվել է:",
    successDelete: "Իրադարձությունը հաջողությամբ ջնջվել է:",
    successUpdate: "Հաջողությամբ թարմացվել է:",
    titleLabel: "Վերնագիր",
    descriptionLabel: "Նկարագրություն",
    colorLabel: "Գույն",
    removeAfterDrop: "Ջնջել տեղափոխումից հետո",
    createEvent: "Ստեղծել իրադարձություն",
  },
  copySuccess: "Հաջողությամբ պատճենվել է:",
  copyTextTitle: "Պատճենել",
  copiedTextTitle: "Պատճենված է",
  ribbon: {
    new: "Նոր",
  },
  coupons: [
    {
      text: "Այս կտրոնը ուժի մեջ է 3 շաբաթ",
      title: "Ոչ կրկնվող տեքստ 20%",
    },
    {
      text: "Այս կտրոնը ուժի մեջ է 2 շաբաթ",
      title: "Կայքի դիզայն 5%",
    },
    {
      text: "Այս կտրոնը կարելի է օգտագործել միայն մեկ անգամ",
      title: "Էջի կառավարում 10%",
    },
    {
      text: "Այս կտրոնը Ձեզ համար ակտիվացված է մշտապես",
      title: "Գրաֆիկական դիզայն 5%",
    },
    {
      text: "Այս կտրոնը կարելի է օգտագործել միայն մեկ անգամ",
      title: "Տպագրություն 2%",
    },
  ],
  userLinks: {
    profile: {
      title: "Ընդհանուր ակնարկ",
      invitation: { title: "Հրավիրել ընկերներին" },
      info: { title: "Անձնական տվյալներ" },
      edit: { title: "Լրացնել պրոֆիլը" },
      changePass: { title: "Փոխել գաղտնաբառը" },
    },
  },
  profileLinks: {
    orders: "Պատվերներ",
    addresses: "Հասցեներ",
  },
  customPage: {
    overview: "Ընդհանուր ակնարկ",
    personalInfo: "Անձնական տվյալներ",
    changePassword: "Փոխել գաղտնաբառը",
    completeProfile: "Լրացնել պրոֆիլը",
    email: "Էլ. փոստ",
    balance: "Մնացորդ",
    phone: "Հեռախոսահամար",
    rial: "Ռիալ",
  },
  widget12: {
    inviteFriends: "Հրավիրել ընկերներին",
    viewInvitedUsers: "Դիտել Ձեր կողմից հրավիրված օգտատերերի ցանկը",
    yourInviteCode: "Ձեր հրավերի կոդը",
    createNewUser: "Ստեղծել նոր օգտատեր",
    copyText: "Պատճենել",
    userCreatedSuccess: "Նոր օգտատերը հաջողությամբ ստեղծվել է",
    notCreated: "Չի ստեղծվել",
  },
  userInfo: {
    userInformation: "Օգտատիրոջ տվյալներ",
    profilePicture: "Պրոֆիլի նկար",
    allowedFileTypes: "Թույլատրվող ֆայլերի տեսակներ՝ png, jpg, jpeg:",
    profilePictureSize:
      "Պրոֆիլի նկարը պետք է լինի քառակուսի (օրինակ՝ 480 × 480):",
    firstName: "Անուն",
    lastName: "Ազգանուն",
    username: "Օգտանուն",
    phone: "Հեռախոսահամար",
    email: "Էլ. փոստ",
    receiveSMS: "SMS-ների ստացում",
    smsCostNote:
      "Ակտիվացնելով այս տարբերակը՝ SMS-ների ուղարկման ծախսերը կհանվեն Ձեր հաշվից:",
    saveChanges: "Պահպանել փոփոխությունները",
    profileUpdated: "Ձեր պրոֆիլը հաջողությամբ թարմացվել է:",
  },
  emailSettings: {
    completeProfile: "Լրացնել պրոֆիլը",
    completeProfileDesc: "Լրացնել անձի կամ կազմակերպության տվյալները",
    cancel: "Չեղարկել",
    update: "Թարմացնել",
    save: "Պահպանել",
    selectPersonType: "Ընտրեք անձի տեսակը",
    realPerson: "Ֆիզիկական անձ",
    legalPerson: "Իրավաբանական անձ",
    phone: "Բջջային հեռախոս",
    landline: "Հաշվիչ հեռախոս",
    fatherName: "Հոր անունը",
    nationalCode: "Ազգային կոդ",
    idNumber: "Անձնագրի համար",
    birthday: "Ծննդյան ամսաթիվ",
    placeOfBirth: "Ծննդավայր",
    postalCode: "Փոստային ինդեքս",
    email: "Էլ. փոստ",
    introduction: "Ինչպե՞ս եք ծանոթացել մեզ հետ",
    nationalCodePic: "Ազգային քարտի լուսանկար",
    plaque: "Տախտակի համար",
    address: "Ամբողջական հասցե",
    companyName: "Ընկերության / խանութի անվանումը",
    registrationNumber: "Գրանցման համար",
    economicCode: "Տնտեսական կոդ",
    organizationIdentity: "Կազմակերպության ազգային ինքնությունը",
    companyType: "Ընկերության տեսակ",
    activity: "Գործունեության ոլորտ",
    registrationAd: "Ընկերության գրանցման հայտարարության պատկեր",
    lastPublishedAd: "Վերջին պաշտոնական հայտարարության պատկեր",
    statute: "Ընկերության կանոնադրության պատկեր",
    agentLetterPic: "Ներկայացուցչի ներկայացման նամակի պատկեր",
    successMessage: "Հաջողությամբ գրանցվել է",
    errorSelectType: "Խնդրում ենք ընտրել տարբերակներից մեկը:",
    rules: {
      companyName: "Ընկերության / խանութի անվան դաշտը պարտադիր է:",
      registrationNumber: "Գրանցման համարի դաշտը պարտադիր է:",
      economicCode: "Տնտեսական կոդի դաշտը պարտադիր է:",
      organizationIdentity:
        "Կազմակերպության ազգային ինքնության դաշտը պարտադիր է:",
      registrationAd: "Գրանցման հայտարարության պատկերը պարտադիր է:",
      lastPublishedAd: "Վերջին պաշտոնական հայտարարության պատկերը պարտադիր է:",
      telephone: "Հաշվիչ հեռախոսի դաշտը պարտադիր է:",
      fatherName: "Հոր անվան դաշտը պարտադիր է:",
      nationalCode: "Ազգային կոդի դաշտը պարտադիր է:",
      birthday: "Ծննդյան ամսաթվի դաշտը պարտադիր է:",
      idNumber: "Անձնագրի համարի դաշտը պարտադիր է:",
      placeOfBirth: "Ծննդավայրի դաշտը պարտադիր է:",
      postalCode: "Փոստային ինդեքսի դաշտը պարտադիր է:",
      nationalCodePic: "Ազգային քարտի լուսանկարի դաշտը պարտադիր է:",
      address: "Հասցեի դաշտը պարտադիր է:",
      plaque: "Տախտակի համարի դաշտը պարտադիր է:",
    },
    companyTypes: {
      governmental: "Պետական",
      private: "Մասնավոր",
      commonStock: "Բաժնետիրական ընկերություն (հանրային)",
      specialStock: "ՍՊԸ / Բաժնետիրական ընկերություն (փակ)",
    },
  },
  changePassword: {
    title: "Փոխել գաղտնաբառը",
    description: "Փոխեք Ձեր հաշվի գաղտնաբառը",
    cancel: "Չեղարկել",
    update: "Թարմացնել",
    passwordInstructions: {
      forgotPassword:
        "Եթե դեռ գաղտնաբառ չեք սահմանել, կարողմեք «Մոռացե՞լ եք գաղտնաբառը» կոճակը:",
      passwordRequirements:
        "Գաղտնաբառը պետք է լինի առնվազն 8 նիշ, պարունակի թվեր, մեծ և փոքր անգլերեն տառեր, ինչպես նաև նշաններ:",
      passwordPrivacy: "Խնդրում ենք չտրամադրել Ձեր գաղտնաբառը ուրիշներին:",
      keyboardLanguage:
        "Գաղտնաբառ սահմանելիս համոզվեք, որ ստեղնաշարը անգլերեն է:",
    },
    currentPassword: "Ընթացիկ գաղտնաբառ",
    newPassword: "Նոր գաղտնաբառ",
    confirmNewPassword: "Հաստատել նոր գաղտնաբառը",
    addOrForgotPassword: "Ավելացնել կամ մոռանալ գաղտնաբառը",
    changePasswordWithCode: "Փոխել գաղտնաբառը SMS-ով",
    close: "Փակել",
    change: "Փոխել",
    enterCode: "Մուտքագրեք կոդը",
    successMessage: "Գաղտնաբառը հաջողությամբ թարմացվել է",
    invalidCode: "Կոդը սխալ է:",
    tooManyAttempts: "Չափից շատ փորձեր:",
    rules: {
      required: "Դաշտը պարտադիր է:",
      min: "Դաշտը պակաս է 8 նիշից",
      equal: "Գաղտնաբառերը չեն համընկնում",
      number: "Մուտքագրեք համարի թվերը",
    },
  },
  router: {
    dashboard: "Վահանակ",
    contacts: "Հաճախորդների ակումբ",
    editContact: "Խմբագրել հաճախորդ",
    createContact: "Ստեղծել հաճախորդ",
    customers: "Հաճախորդների ցանկ",
    contactList: "Կոնտակտ օգնական",
    messages: "Հաղորդագրություններ",
    messageCategories: "Հաղորդագրությունների կատեգորիաներ",
    oldTransactions: "Հին գործարքներ",
    yourTransactions: "Ձեր գործարքները",
    buyPanel: "Գնել վահանակ",
    permissions: "Թույլտվություններ",
    createPermission: "Ստեղծել թույլտվություն",
    invitations: "Իմ հրավերները",
    editUser: "Խմբագրել օգտատիրոջը",
    userInformation: "Դիտել օգտատիրոջ տվյալները",
    walletEdit: "Խմբագրել օգտատիրոջ դրամապանակը",
    userHistory: "Օգտատիրոջ պատմություն",
    userNotificationsHistory: "Օգտատերերի ծանուցումների պատմություն",
    notifications: "Ծանուցումներ",
    createNotification: "Ստեղծել ծանուցում",
    editNotification: "Խմբագրել ծանուցումը",
    adminNotifications: "Ադմինի ծանուցումներ",
    yourNotifications: "Ձեր ծանուցումները",
    adminNotificationsList: "Կառավարչի ծանուցումներ",
    tickets: "Տոմսեր",
    createTicket: "Գրանցել նոր տոմս",
    editTicket: "Խմբագրել տոմսը",
    departments: "Բաժիններ",
    createDepartment: "Նոր բաժին",
    editDepartment: "Խմբագրել բաժինը",
    adminTickets: "Տոմսերի կառավարում",
    discounts: "Զեղչեր",
    createDiscount: "Ստեղծել զեղչ",
    editDiscount: "Խմբագրել զեղչը",
    workReports: "Աշխատանքային հաշվետվություններ",
    createWorkReport: "Ստեղծել հաշվետվություն",
    callMonitoring: "Զանգերի մոնիթորինգ",
    adminWorkReports: "Աշխատանքային հաշվետվությունների կառավարում",
    editWorkReport: "Դիտել և խմբագրել հաշվետվությունը",
    packProperties: "Փաթեթի բնութագրեր",
    createPackProperty: "Ստեղծել փաթեթի բնութագիր",
    editPackProperty: "Խմբագրել փաթեթի բնութագիրը",
    panels: "Վահանակներ",
    createPanel: "Ստեղծել վահանակ",
    editPanel: "Խմբագրել վահանակը",
    transferRequests: "Հաշվից դուրսբերման հայտեր",
    editTransferRequest: "Խմբագրել դուրսբերման հայտը",
    tariffs: "Սակագներ",
    createTariff: "Ստեղծել սակագին",
    editTariff: "Խմբագրել սակագինը",
    requests: "Հայտեր",
    viewUser: "Դիտել օգտատիրոջը",
    manageTransactions: "Գործարքների կառավարում",
    viewTransaction: "Դիտել գործարքը",
    manageConfigs: "Կարգավորումների կառավարում",
    rbLandConfigs: "Robot Land կարգավորումների կառավարում",
    editConfig: "Խմբագրել կարգավորումները",
    manageUsers: "Օգտատերերի կառավարում",
    categories: "Կատեգորիաներ",
    createCategory: "Ավելացնել կատեգորիա",
    editCategory: "Խմբագրել կատեգորիան",
    content: "Բովանդակություն",
    createContent: "Ավելացնել բովանդակություն",
    editContent: "Խմբագրել բովանդակությունը",
    addUserGuide: "Ավելացնել օգտատիրոջ ուղեցույց",
    editUserGuide: "Խմբագրել օգտատիրոջ ուղեցույցը",
    roles: "Դերեր",
    editRole: "Խմբագրել դերը",
    createRole: "Ավելացնել դեր",
    permissionTitle: "Թույլտվություններ",
    paymentGateways: "Վճարման դարպասներ",
    editPaymentGateway: "Խմբագրել վճարման դարպասը",
    campaigns: "Արշավներ",
    createCampaign: "Ստեղծել արշավ",
    editCampaign: "Խմբագրել արշավի տվյալները",
    adminCustomers: "Հաճախորդներ",
    createCustomer: "Ստեղծել հաճախորդ",
    editCustomerInfo: "Խմբագրել հաճախորդի տվյալները",
    referrerCustomers: "Հրավիրված հաճախորդներ",
    customerHistory: "Հաճախորդի պատմություն",
    userProfile: "Օգտատիրոջ պրոֆիլ",
    editProfile: "Խմբագրել պրոֆիլը",
    inviteFriends: "Հրավիրել ընկերներին",
    personalInfo: "Անձնական տվյալներ",
    editPersonalInfo: "Խմբագրել տվյալները",
    changePassword: "Փոխել գաղտնաբառը",
    newWallet: "Նոր դրամապանակ",
  },
  profileView: {
    email: "Էլ. փոստ",
    balance: "Մնացորդ",
    personType: "Անձի տեսակ",
    currency: "Ռիալ",
    unknown: "----",
  },
  panelInfoProfile: {
    panelTitle: "Դուք ունեք «{title}» վահանակը, որը ունի {days} օր ժամկետ։",
    buyOrRenew:
      "Վահանակ գնելու կամ երկարացնելու համար սեղմեք ստորև բերված կոճակը։",
    buyPanel: "Գնել վահանاک",
    percentage: "%",
  },
  profileSetting: {
    cardTitle: "Պրոֆիլի կարգավորումներ",
    changePasswordTitle: "Փոխել մուտքի գաղտնաբառը",
    changePasswordSubtitle: "Փոխեք Ձեր հաշվի մուտքի գաղտնաբառը։",
    alertMessage:
      "Եթե մինչ այժմ գաղտնաբառ չեք սահմանել, ակտիվացրեք «Գրանցել գաղտնաբառ» տարբերակը։",
    currentPasswordLabel: "Ընթացիկ գաղտնաբառ",
    setPasswordLabel: "Գրանցել գաղտնաբառ",
    addPassword: "Ավելացնել գաղտնաբառ",
    newPasswordLabel: "Նոր գաղտնաբառ",
    repeatPasswordLabel: "Կրկնել գաղտնաբառը",
    saveChanges: "Պահպանել փոփոխությունները",
    currentPasswordPlaceholder: "Ընթացիկ գաղտնաբառ",
    newPasswordPlaceholder: "Նոր գաղտնաբառ",
    repeatPasswordPlaceholder: "Կրկնել գաղտնաբառը",
  },
  profileOrders: {
    cardTitle: "Պատվերներ",
    openOrders: "Բաց պատվերներ ({count})",
    closedOrders: "Փակված պատվերներ ({count})",
    noOrders: "Դեռ պատվերներ չունեք մեզանից",
  },
  personalInformation: {
    cardTitle: "Անձնական հաշվի տվյալներ",
    cardSubtitle: "Թարմացրեք Ձեր անձնական տվյալները։",
    cancel: "Չեղարկել",
    update: "Թարմացնել",
    yourInfo: "Ձեր տվյալները",
    profilePicture: "Պրոֆիլի նկար",
    allowedFileTypes: "Թույլատրվող ֆայլեր՝ png, jpg, jpeg։",
    pictureSize: "Պրոֆիլի նկարը պետք է քառակուսի լինի (օրինակ՝ 480 × 480):",
    name: "Անուն",
    lastName: "Ազգանուն",
    username: "Օգտանուն",
    receiveSMS: "SMS-ների ստացում",
    smsCostNote:
      "Ակտիվացնելով այս տարբերակը՝ SMS-ների ուղարկման ծախսերը կհանվեն Ձեր հաշվից։",
    phoneNumber: "Բջջային համար",
    phonePlaceholder: "Բջջային համար",
    email: "Էլ. փոստ",
    emailPlaceholder: "Էլ. փոստ",
    emailPrivacy: "Մենք երբեք Ձեր էլ. փոստը չենք կիսում ուրիշների հետ։",
    successMessage: "Ձեր պրոֆիլը հաջողությամբ թարմացվել է։",
  },
  userInfoForm: {
    companyName: "Ընկերության / խանութի անվանումը",
    registrationNumber: "Գրանցման համար",
    economicCode: "Տնտեսական կոդ",
    organizationIdentity: "Կազմակերպության ազգային ինքնությունը",
    companyType: "Ընկերության տեսակ",
    activity: "Գործունեության ոլորտ",
    registrationAd: "Ընկերության գրանցման հայտարարության պատկեր",
    lastPublishedAd: "Վերջին պաշտոնական հայտարարության պատկեր",
    statute: "Ընկերության կանոնադրության պատկեր",
    argentLetterPic: "Ներկայացուցչի ներկայացման նամակի պատկեր",
    phone: "Բջջային համար",
    telephone: "Հաշվիչ հեռախոս",
    fatherName: "Հոր անունը",
    nationalCode: "Ազգային կոդ",
    id: "Անձնագրի համար",
    birthday: "Ծննդյան ամսաթիվ",
    placeBirthday: "Ծննդավայր",
    postalCode: "Փոստային ինդեքս",
    email: "Էլ. փոստ",
    introduction: "Ինչպե՞ս եք ծանոթացել մեզ հետ",
    nationalCodePic: "Ազգային քարտի լուսանկար",
    plaque: "Տախտակի համար",
    address: "Ամբողջական հասցե",
    companyTypes: {
      governmental: "Պետական",
      private: "Մասնավոր",
      common_stock: "Բաժնետիրական ընկերություն (հանրային)",
      special_stock: "ՍՊԸ / Բաժնետիրական ընկերություն (փակ)",
    },
    rules: {
      companyName: "Ընկերության / խանութի անվան դաշտը պարտադիր է։",
      registration_number: "Գրանցման համարի դաշտը պարտադիր է։",
      economic_code: "Տնտեսական կոդի դաշտը պարտադիր է։",
      organization_identity:
        "Կազմակերպության ազգային ինքնության դաշտը պարտադիր է։",
      registration_ad: "Գրանցման հայտարարության պատկերը պարտադիր է։",
      last_published_ad: "Վերջին պաշտոնական հայտարարության պատկերը պարտադիր է։",
      telephone: "Հաշվիչ հեռախոսի դաշտը պարտադիր է։",
      fatherName: "Հոր անվան դաշտը պարտադիր է։",
      nationalCode: "Ազգային կոդի դաշտը պարտադիր է։",
      id: "Անձնագրի համարի դաշտը պարտադիր է։",
      birthday: "Ծննդյան ամսաթվի դաշտը պարտադիր է։",
      placeBirthday: "Ծննդավայրի դաշտը պարտադիր է։",
      postalCode: "Փոստային ինդեքսի դաշտը պարտադիր է։",
      nationalCodePic: "Ազգային քարտի լուսանկարի դաշտը պարտադիր է։",
      address: "Հասցեի դաշտը պարտադիր է։",
      plaque: "Տախտակի համարի դաշտը պարտադիր է։",
    },
  },
  createUserForm: {
    name: "Անուն",
    lastName: "Ազգանուն",
    nid: "Ազգային կոդ",
    phone: "Բջջային համար",
    create: "Ստեղծել",
    errors: {
      nameRequired: "Անունը մուտքագրված չէ։",
      lastNameRequired: "Ազգանունը մուտքագրված չէ։",
      nidRequired: "Ազգային կոդը մուտքագրված չէ։",
      phoneRequired: "Բջջային համարը մուտքագրված չէ։",
    },
  },
  lastView: {
    cardTitle: "Ձեր վերջին այցելությունները",
    cardSubtitle: "Մեր էջերից Ձեր վերջին այցելությունները",
    tableHeaders: {
      page: "Էջ",
      address: "Հասցե",
      enterDate: "Մուտքի ամսաթիվ",
      leaveDate: "Ելքի ամսաթիվ",
      timeSpent: "Այս էջում անցկացրած ժամանակը",
    },
    viewAll: "Դիտել բոլորը",
    timeUnit: "րոպե",
    pages: {
      home: "Գլխավոր",
      panels: "Վահանակներ",
      profile: "Լրացնել պրոֆիլը",
    },
  },
walletWidget: {
  title: "Վերջին գործարքները",
  balanceLabel: "Ձեր մնացորդը՝",
  viewTransactions: "Դիտել գործարքները",
  transactionTypes: {
    withdraw: "Ելքագրում",
    deposit: "Մուտքագրում",
    charge: "Դրամապանակի լիցքավորում",
    refund: "Վերադարձ",
    default: "Գործարք",
    adminCharge: "Ադմինիստրատորի ճշգրտում",
    agency: "Գործակալության միջնորդավճար",
  },
},
  panelWidget: {
    title: "Դուք ունեք «{title}» վահանակը ({days} օր):",
    renewPrompt:
      "Վահանակ գնելու կամ երկարացնելու համար սեղմեք ստորև բերված կոճակը։",
    buyPanel: "Գնել վահանակ",
    percentage: "{value}%",
    infinity: "∞",
    days: "{count} օր",
  },
  component: {
    title: "Ձեր կողմից հրավիրված օգտատերերը",
    columns: {
      row: "Համար",
      name: "Անուն",
      family: "Ազգանուն",
      username: "Օգտանուն",
      phone: "Բջջային",
      created_at: "Գրանցման ամսաթիվ",
      actions: "Գործողություններ",
    },
    unknown: "Անհայտ",
    error: "Սխալ",
    breadcrumb: "Հրավիրված օգտատերեր",
  },
  table: {
    itemsPerPage: "Տողերի քանակը մեկ էջում",
    pageText: "Ցուցադրվում է {0}-ից {1} մինչև {2} գրառումներից",
    prevText: "Նախորդ",
    nextText: "Հաջորդ",
    noDataText: "Տվյալներ չկան",
    search: "Որոնել",
  },
  UserHistory: {
    title: "Օգտատերերի պատմություն",
    add_history: "Գրանցել նոր պատմություն",
    send_message: "Ուղարկել հաղորդագրություն",
    close: "Փակել",
    save: "Պահպանել",
    cancel: "Չեղարկել",
    new_history_dialog_title: "Գրանցել նոր պատմություն",
    send_message_dialog_title: "Ուղարկել հաղորդագրություն",
    negotiations: "Կատարված բանակցություններ",
    follow_up: "Հաջորդ զանգի հետևման կետեր",
    success_history: "Պատմությունը հաջողությամբ գրանցվել է։",
    success_message: "Հաղորդագրությունը հաջողությամբ ուղարկվել է։",
    columns: {
      id: "ID",
      title: "Վերնագիր",
      status: "Փուլ",
      current_time_date: "Վերջին զանգի ամսաթիվ",
      current_time_hour: "Վերջին զանգի ժամ",
      next_time_date: "Հաջորդ զանգի ամսաթիվ",
      next_time_hour: "Հաջորդ զանգի ժամ",
      user_id: "Աջակցություն",
      actions: "Գործողություններ",
    },
    table: {
      itemsPerPage: "Տողերի քանակը մեկ էջում",
      pageText: "Ցուցադրվում է {0}-ից {1} մինչև {2} գրառումներից",
      prevText: "Նախորդ",
      nextText: "Հաջորդ",
      noDataText: "Տվյալներ չկան",
      search: "Որոնել",
    },
    form: {
      title: "Վերնագիր",
      status: "Փուլ",
      current_time: "Վերջին զանգի ամսաթիվ",
      description: "Նկարագրություն",
      next_time: "Հաջորդ զանգի ամսաթիվ",
      pursue_text: "Հաջորդ զանգի հետևում",
      category: "Ընտրել կատեգորիա",
      message_title: "Հաղորդագրության վերնագիր",
    },
  },
  newUserTransactions: {
    userWallet: "Օգտատիրոջ դրամապանակ",
    transactionList: "Գործարքների ցանկ",
    userTransactions: "Օգտատիրոջ գործարքներ",
    terminal: "Տերմինալ",
    liveSms: "Կենդանի SMS",
    realEstateNews: "Divar-ի նորությունները",
    rial: "Ռիալ",
    row: "Համար",
    uniqueId: "ID",
    amount: "Գումար",
    time: "Ժամ",
    createdAt: "Ամսաթիվ",
    description: "Հավելյալ նկարագրություն",
    type: "Գործարքի տեսակ",
    product_description: "Նկարագրություն",
    serviceId: "Ծառայության անվանում",
    balanceAfter: "Մնացորդը գործարքից հետո",
    perPage: "Քանակ",
    search: "Որոնել",
    balance: "Մնացորդ",
    transactionListTooltip: "Գործարքների ցանկ",
    panelLogin: "Մուտք վահանակ",
    history: "Պատմություն",
    error: {
      terminalWallet: "Սխալ՝ տերմինալի դրամապանակը ստանալիս",
      imageLoad: "Սխալ՝ պատկերը բեռնելիս։",
    },
    transactionType: "Գործարքի տեսակ",
    service: "Ծառայություն",
    dateFrom: "Ամսաթիվը՝ սկսած",
    dateTo: "մինչև ամսաթիվ",
    oldWallet: "Հին դրամապանակ",
    depositReceipt: "Մուտքագրման անդորրագիր",
    showReceipt: "Ցուցադրել անդորրագիրը",
    transactionTypes: {
      online: "Առցանց",
      admin: "Ադմինի կողմից",
      refund: "Ուղղիչ գործարք",
      agency: "Գործակալություն",
      withdraw: "Ելք",
      deposit: "Մուտք",
      adminCharge: "Ադմինի լիցքավորում",
      charge: "Դրամապանակի լիցքավորում",
      refund: "Վերադարձ",
    },
  },
  buyPanel: {
    alert: {
      choosePanel: "Խնդրում ենք ուշադիր ընտրել վահանակի տեսակը։",
    },
    dialog: {
      title: "Վահանակի գնում",
      confirmPurchase: "Համոզվա՞ծ եք, որ ցանկանում եք գնել «{title}» վահանակը։",
      discountCodeLabel: "Զեղչի կոդ",
      discountCodePlaceholder: "Մուտքագրեք Ձեր զեղչի կոդը",
      applyDiscount: "Կիրառել կոդը",
      purchase: "Գնել",
      iHaveDiscount: "Ունեմ զեղչի կոդ",
    },
    toast: {
      discountApplied: "Ձեր զեղչի կոդը հաջողությամբ կիրառվել է։",
      purchaseSuccess: "Փաթեթը հաջողությամբ գնվել է",
      error: "Սխալ է տեղի ունեցել՝ {message}",
      unauthorized: "Խնդրում ենք նախ մուտք գործել",
      validationError: "Ստուգման սխալ՝ {message}",
    },
    currency: "Ռիալ",
  },
  panelCard: {
    rial: "Ռիալ",
    days: "օր",
    buyPanel: "Գնել վահանակ",
  },
  cons: {
    title: "Ընտրել էմոջի",
  },
  cons1: {
    title: "Կանխադրված տեքստ",
  },
  MENUS: {
    AD_TERMINAL_SYSTEM: "Գովազդային մեծ տերմինալ համակարգ",
  },
};
